<script>
    import AppIcon from "./components/AppIcon.svelte";

    let logo = "images/SmallLogo@2x.png";

    const primary = "#ed1978";
    const secondary = "#009de6";
    const accent = "#fec11e";
    const green = "#00cd60";

    const instagramGradient =
        "linear-gradient( 62deg, rgb(249,237,50) 0%, rgb(238,42,123) 62%, rgb(8,51,171) 100%)";

    const facebookLink = "https://www.facebook.com/cherrydarlingsbakehouse";
    const instagramLink = "https://www.instagram.com/cherrydarlingsbakehouse/";
    const emailLink = "mailto:cherrydarlingsbakehouse@gmail.com";
    const phoneLink = "tel:(08)81236377";
</script>

<main
    style="--primary:{primary};--secondary:{secondary};--accent:{accent};--green:{green}"
>
    <div class="header-angle" />
    <div class="header" />
    <div class="logo-holder">
        <img src={logo} width="176" height="122" />
    </div>
    <div class="body-angle" />
    <div class="body">
        <div class="content">
            <h1>Cherry Darlings Bakehouse</h1>
            <p>
                Our final day trading is the 25th of January, we will be permanently closed from this date onwards.
            </p>
            <p>If you'd like to keep updated on any future Cherry's news, please follow us on <a class="highlight" href={facebookLink}>Facebook</a> or <a class="highlight" href={instagramLink}>Instagram</a>
        </div>
    </div>
    <div class="socials">
        <AppIcon
            letter={"F"}
            text={"Facebook"}
            background={"#4267b2"}
            link={facebookLink}
        />
        <AppIcon
            letter={"I"}
            text={"Instagram"}
            background={instagramGradient}
            link={instagramLink}
        />
        <AppIcon
            letter={"E"}
            text={"Email"}
            background={primary}
            link={emailLink}
        />
        <AppIcon
            letter={"P"}
            text={"Phone"}
            background={secondary}
            link={phoneLink}
        />
    </div>
    <div class="footer" />
</main>

<style lang="scss">
    $primary: var(--primary);
    $secondary: var(--secondary);
    $accent: var(--accent);
    $green: var(--green);


    main {
        position: relative;
        width: 100vw;

        overflow-x: hidden;

        overflow-y: hidden;

        padding: 0px 0px 0px 0px;
    }

    .logo-holder {
        display: flex;

        width: 100vw;

        margin-top: 35px;

        align-items: center;
        justify-content: center;

        position: fixed;

        z-index: 1000;
    }

    .header {
        width: 200vw;
        height: 100vw;

        background-color: $primary;

        margin-left: -50vw;

        margin-top: calc(-100vw + 100px);

        transform: rotate(7deg);

        z-index: 11;

        position: fixed;
    }

    .header-angle {
        background-color: black;

        width: 200vw;
        height: 100vw;

        transform: rotate(8deg);

        margin-top: calc(-100vw + 20px);

        top: 100px;

        margin-left: -50vw;

        position: fixed;

        box-shadow: 0px 0px 20px 10px rgba(0, 0, 0, 0.2);
        z-index: 10;
    }

    .body {
        display: flex;
        align-items: center;
        justify-content: center;

        width: 100%;

        margin-top: 0px;

        padding: 200px 20px 40px 20px;

        box-sizing: border-box;


        .content {
            max-width: 420px;
        }

        h1 {
            font-size: 24px;
            text-align: center;

            line-height: 28px;

            text-shadow: 2px 2px rgba(0, 0, 0, 1);

            font-weight: bold;
        }

        p {
            text-align: center;

            font-size: 18px;
        }

        .highlight {
            color: $accent;
        }

    }

    .body-angle {
        background-color: $secondary;

        width: 200vw;
        height: 460px;

        margin-left: -50vw;

        transform: rotate(8deg);

        position: absolute;

        z-index: -1;

        margin-top: 100px;
    }

    .map {
        display: flex;

        width: 100%;

        flex-direction: column;

        justify-content: center;

        align-items: center;

        margin-bottom: 10px;

        box-sizing: border-box;

        .map-border {
            padding: 20px 14px 18px 14px;
            background-color: black;

            transform: rotate(-1deg);

            iframe {
                transform: rotate(1deg);

                @media (max-width: 720px) {
                    width: 360px;
                    height: 260px;

                    max-width: calc(100vw - 50px);
                }
            }
        }

        .address {
            width: 420px;

            padding: 30px 20px 30px 20px;

            margin-top: 10px;

            box-sizing: border-box;

            text-align: center;

            color: black;

            font-weight: bold;

            font-size: 18px;

            line-height: 24px;

            @media (max-width: 720px) {
                width: calc(100vw - 40px);

                box-sizing: border-box;
            }
        }
    }

    .hours-wrapper {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: center;

        box-sizing: border-box;

        .opening-hours {
            width: 420px;

            text-align: center;

            @media (max-width: 720px) {
                width: calc(100vw - 40px);

                box-sizing: border-box;
            }

            .hours {
                background-color: black;
                padding: 10px 20px;
                font-size: 18px;

                line-height: 24px;

                margin-bottom: 10px;
            }

            .highlight {
                color: $primary;
            }
        }
    }

    .socials {
        margin: 140px auto 0px auto;

        padding: 20px 20px 100px 20px;

        display: flex;
        flex-direction: row;

        max-width: 420px;

        align-items: center;
        justify-content: space-between;

        box-sizing: border-box;
    }

    .footer {
        background-color: $green;

        width: 200vw;
        height: 600px;

        margin-left: -50vw;

        transform: rotate(8deg);

        position: absolute;

        z-index: -2;

        margin-top: -300px;
    }
</style>
